import React from 'react'
import { Navigation_v2, Footer_v2 } from '@fjordline/sanity-types'
import navigationItems from './navigationItems.json'
import NavbarNew from './navbar/Navbar'
import useFetchFooter from '../sanity/footer/useFetchFooter'
import { useKeycloak, useKeycloakOperations } from '../providers/KeycloakProvider'
import { useTranslation } from 'react-i18next'
import { Locale } from './navbar/Navbar'
import AddExtrasModalProvider from './navbar/AddExtrasModalProvider'
import { ENVIRONMENT } from '../config'

interface NavigationAndFooterProps {
  children: React.ReactNode;
}

export const NavigationAndFooter: React.FC<NavigationAndFooterProps> = ({ children }) => {
    const { isAuthenticated: kc_isAuthenticated, userEmail, isLoading } = useKeycloak()
    const { logout: kc_logout, updatePassword } = useKeycloakOperations()

    const isAuthenticated = kc_isAuthenticated

    const { i18n } = useTranslation()

    const { data } = useFetchFooter(i18n.language);
    const footer = data?.[0] as Footer_v2;

    const root = ENVIRONMENT === 'PROD' ? 'https://www.fjordline.com' : 'https://homeport-test.fjordline.com'

    return (
      <NavbarNew
        // AUTH_REGISTRATION_URL=""
        // MIGRATION_SERVICE_URL=""
        isDevelopment={true}
        navigationMenu={navigationItems as Navigation_v2}
        footerMenu={footer}
        locale={i18n.language as Locale}
        signIn={() => {}}
        signOut={kc_isAuthenticated
            ? async () => {
                if (kc_isAuthenticated) {
                  kc_logout()
                }
              }
            : async () => {}}
        updatePassword={kc_isAuthenticated
          ? async () => {
              if (kc_isAuthenticated) {
                updatePassword()
              }
            }
          : async () => {}
        }
        status={isAuthenticated ? 'authenticated' : isLoading ? 'loading' : 'unauthenticated'}
        email={userEmail}
        baseUrl={root}
      >
        <AddExtrasModalProvider>{children}</AddExtrasModalProvider>
      </NavbarNew>
    )
  }